// MARK: React
import * as React from "react";
import { observer, inject } from "mobx-react";
import "./style.scss";

// MARK: Components
import TextField from "../../../../components/TextField";
import ImageCase from "../../../../components/ImageCase";
import Button from "../../../../components/Button";
import Divider from "../../../../components/Divider";

// MARK: Stores
import RoomStore from "../../../../stores/RoomStore";
import { routerStore } from "../../../../stores/_rootStore";

// MARK: Resources
import strings from "../../../../resources/strings";
import { match as Match } from "react-router";

interface IProps {
	roomStore: RoomStore;
	match: Match<{ roomId?: string }>;
}

@inject("roomStore")
@observer
export default class RoomCreateOrEdit extends React.Component<IProps> {
	public componentDidMount = async () => {
		const roomId = this.props.match.params.roomId;
		if (roomId) {
			await this.props.roomStore.getRoom(roomId);
		}
	};

	public render() {
		const { roomStore } = this.props;
		return (
			<div className="roomCreateOrEdit">
				{!roomStore.loading && (
					<div className="roomCreateOrEditWrapper">
						<h1 className="roomCreateOrEditTitle">{roomStore.selectedRoom ? strings.rooms.createOrEdit.title.edit : strings.rooms.createOrEdit.title.new}</h1>
						<div className="roomFormContainer">
							<h2>{strings.rooms.createOrEdit.sections.data}</h2>
							<TextField
								label={strings.rooms.createOrEdit.fields.nick}
								name="nick"
								value={roomStore.nick}
								onChange={roomStore.handleValueChange}
								disabled={roomStore.loading}
								required={true}
							/>
							<TextField
								label={strings.rooms.createOrEdit.fields.name}
								name="name"
								value={roomStore.name}
								onChange={roomStore.handleValueChange}
								disabled={roomStore.loading}
								required={true}
							/>
							<TextField
								label={strings.rooms.createOrEdit.fields.description}
								name="description"
								multiline={true}
								value={roomStore.description}
								onChange={roomStore.handleValueChange}
								disabled={roomStore.loading}
							/>
							<TextField
								label={strings.rooms.createOrEdit.fields.url}
								name="url"
								value={roomStore.url}
								onChange={roomStore.handleValueChange}
								disabled={roomStore.loading}
							/>
							<TextField
								label={strings.rooms.createOrEdit.fields.positionRoom}
								name="order"
								type="number"
								inputProps={{ min: "0" }}
								value={roomStore.order}
								onChange={roomStore.handleValueChange}
								disabled={roomStore.loading}
								required={false}
							/>
						</div>
						<Divider className="divider" />
						<ImageCase
							title={strings.rooms.createOrEdit.fields.capacity}
							onAddItem={roomStore.layoutsImageService.selectImages}
							onRemoveItem={roomStore.layoutsImageService.removeImage}
							onReloadItem={roomStore.layoutsImageService.reloadImage}
							imageUploaders={roomStore.layoutsImageService.imageUploaders}
						/>
						<Divider className="divider" />
						<ImageCase
							title={strings.rooms.createOrEdit.fields.imageTitle}
							onAddItem={roomStore.imageService.selectImages}
							onRemoveItem={roomStore.imageService.removeImage}
							onReloadItem={roomStore.imageService.reloadImage}
							imageUploaders={roomStore.imageService.imageUploaders}
						/>
						<div className="buttonsContainer">
							<Button
								onClick={() => roomStore.createOrEditRoom()}
								style={{ backgroundColor: "#0081B0", color: "white" }}
							>
								{strings.rooms.createOrEdit.buttons.save}
							</Button>
							<Button
								onClick={() => routerStore.push("/dashboard/rooms")}
							>
								{strings.rooms.createOrEdit.buttons.back}
							</Button>
						</div>
					</div>
				)}
			</div>
		);
	}
}
